<template>
  <div class="ui-range-input">
    <UiLabel
      v-if="label"
      :label="label"
      class="t:mb-8"
    />
    <div class="t:flex t:items-center ">
      <UiInput
        ref="input"
        v-model="currentValue.min"
        :disabled="disabled"
        :error="errors.total || errors.min"
        :tabindex="1"
        error-tooltip
        class="ui-range-input__input"
        autosize
        type="text"
        :placeholder="$t(`affiliates.offer_popup.range_min`)"
        name="min"
        @update:model-value="handleMinInput"
      />
      <UiIcon
        name="horizontal-rule"
        color="var(--text-body-tertiary)"
        class="t:mx-4"
      />
      <UiInput
        v-model="currentValue.max"
        :error="errors.total || errors.max"
        :tabindex="2"
        :disabled="disabled"
        error-tooltip
        autosize
        type="text"
        class="ui-range-input__input"
        :placeholder="$t(`affiliates.offer_popup.range_max`)"
        @update:model-value="handleMaxInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiRangeInput',
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'number',
    },
    int: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    error: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
    errorTooltip: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'blur', 'focus'],
  data() {
    return {
      currentValue: {
        min: '',
        max: '',
      },
      readyValue: {
        min: '',
        max: '',
      },
      errors: {
        total: null,
        min: null,
        max: null,
      },
      focused: false,
      errorText: '',
    };
  },
  computed: {
    multiplier() {
      return this.type === 'currency' ? 100 : 1;
    },
  },
  watch: {
    error: {
      deep: true,
      handler(nv) {
        this.errors = this.$_.cloneDeep({
          total: null,
          min: null,
          max: null,
        });

        if (this.$_.isArray(nv)) {
          this.errors.total = this.$_.cloneDeep(nv[0].message);
        }

        if (this.$_.isObject(nv)) {
          this.errors = {
            ...this.errors,
            min: nv.min,
            max: nv.max,
          };
        }
      },
    },
    value: {
      deep: true,
      handler(nv) {
        if (nv.min || nv.min === 0) {
          if (nv.min / this.multiplier !== parseFloat(this.currentValue.min)) {
            this.currentValue.min = nv.min / this.multiplier;
          }
        } else {
          this.currentValue.min = '';
        }
        if (nv.max || nv.max === 0) {
          if (nv.max / this.multiplier !== parseFloat(this.currentValue.max)) {
            this.currentValue.max = nv.max / this.multiplier;
          }
        } else {
          this.currentValue.max = '';
        }
      },
    },
    currentValue: {
      deep: true,
      handler(nv) {
        if (nv.min !== this.readyValue.min || nv.max !== this.readyValue.max) {
          this.readyValue.min = this.prepareValue(parseFloat(nv.min) * this.multiplier);
          this.readyValue.max = this.prepareValue(parseFloat(nv.max) * this.multiplier);
          this.$emit('change', this.readyValue);
        }
      },
    },
  },
  created() {
    this.currentValue.min = (this.value.min || this.value.min === 0) ? this.value.min / this.multiplier : '';
    this.currentValue.max = (this.value.max || this.value.max === 0) ? this.value.max / this.multiplier : '';
  },
  // mounted() {

  // },
  methods: {
    prepareValue(val) {
      if (val || val === 0) {
        return val;
      }

      return null;
    },
    handleMinInput(value) {
      const val = value;
      this.currentValue.min = (this.type === 'coef' || !this.int) ? val.replace(/[^.0-9]/g, '').replace(/^([^.]*\.)|\./g, '$1') : val.replace(/[^0-9]/g, '');
    },
    handleMaxInput(value) {
      const val = value;
      this.currentValue.max = (this.type === 'coef' || !this.int) ? val.replace(/[^.0-9]/g, '').replace(/^([^.]*\.)|\./g, '$1') : val.replace(/[^0-9]/g, '');
    },
    handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },
    focus() {
      this.$refs.input.focus();
    },
    blur() {
      this.$refs.input.blur();
    },
    select() {
      this.$refs.input.select();
    },
  },
};
</script>

<style lang="scss">
.ui-range-input {
  position: relative;
  width: 194px;
  &__input {
    min-width: 10%;
    max-width: 100%;
    flex: 10 1 auto;
  }
}
</style>
<style lang="scss">
.ui-range-input {

  .error-msg {
    position: absolute;
    align-self: center;
    top: 74px;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
  }
}
</style>
